var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Select as BaseSelect, Box, useTheme } from "native-base";
import { isWeb } from "@madmedical/utils";
import Icon from "../icons/Icon";
const Select = (_a) => {
    var { choices, size = "sm", value, onChange } = _a, rest = __rest(_a, ["choices", "size", "value", "onChange"]);
    const { colors } = useTheme();
    const sizes = useMemo(() => ({
        sm: {
            fontSize: "sm",
            height: "35px",
            px: 3,
            py: 2,
            my: isWeb ? 0 : 2,
        },
        md: {
            fontSize: "md",
            height: "40px",
            px: 4,
            py: 2,
        },
        xl: {
            fontSize: "md",
            height: "50px",
            px: 4,
            py: 4,
        },
    }), []);
    return (_jsx(BaseSelect, Object.assign({ isFocusVisible: false, dropdownIcon: _jsx(Box, Object.assign({ p: 2 }, { children: _jsx(Icon, { name: "chevronDown", size: 16, fill: colors.gray[800] }) })), selectedValue: value, onValueChange: onChange }, sizes[size], rest, { children: choices.map((item) => (_jsx(BaseSelect.Item, { value: item.value, label: item.label }, item.value))) })));
};
export default Select;
